// extracted by mini-css-extract-plugin
export default {"expand":"UsunLege_expand__mBLYL"};